<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="外观">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{xingcaiDetail.wujian_id}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{xingcaiDetail.wujian_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">订单号</div>
                <div>{{xingcaiDetail.purchase_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">型材番号</div>
                <div>{{xingcaiDetail.xingcai_no}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查数量</div>
                <div>{{xingcaiDetail.checked_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">入荷日</div>
                <div>{{xingcaiDetail.in_date}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">长度</div>
                <div>{{xingcaiDetail.length}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">幅宽/W</div>
                <div>{{xingcaiDetail.breadth}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">到货数</div>
                <div>{{xingcaiDetail.in_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">硬度抽检</div>
                <div v-if="xingcaiDetail.hardness_status !== undefined">{{xingcaiDetail.hardness_statusText}}</div>
                <div v-else>———</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">尺寸抽检</div>
                <div v-if="xingcaiDetail.chicun_status !== undefined">{{xingcaiDetail.chicun_statusText}}</div>
                <div v-else>———</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">膜厚抽检</div>
                <div v-if="xingcaiDetail.thickness_status !== undefined">{{xingcaiDetail.thickness_statusText}}</div>
                <div v-else>———</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{xingcaiDetail.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{xingcaiDetail.create_time}}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv">
              <div class="fontBold">炉号：</div>
              <div>{{xingcaiDetail.furnace_no}}</div>
            </div>
            <el-image v-for="imageUrl in xingcaiDetail.furnace_pics_list" :preview-src-list="xingcaiDetail.furnace_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            <div class="nowrapDiv">
              <div class="fontBold">划伤：</div>
              <div v-if="xingcaiDetail.huashang" style="color: red">{{ getResultText(xingcaiDetail.huashang) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.huashang) }}</div>
            </div>
            <div v-show="xingcaiDetail.huashang">
              <el-image v-for="imageUrl in xingcaiDetail.huashang_pics_list" :preview-src-list="xingcaiDetail.huashang_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">腐蚀：</div>
              <div v-if="xingcaiDetail.fushi" style="color: red">{{ getResultText(xingcaiDetail.fushi) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.fushi) }}</div>
            </div>
            <div v-show="xingcaiDetail.fushi">
              <el-image v-for="imageUrl in xingcaiDetail.fushi_pics_list" :preview-src-list="xingcaiDetail.fushi_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">凹陷：</div>
              <div v-if="xingcaiDetail.aoxian" style="color: red">{{ getResultText(xingcaiDetail.aoxian) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.aoxian) }}</div>
            </div>
            <div v-show="xingcaiDetail.aoxian">
              <el-image v-for="imageUrl in xingcaiDetail.aoxian_pics_list" :preview-src-list="xingcaiDetail.aoxian_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">擦伤：</div>
              <div v-if="xingcaiDetail.cashang" style="color: red">{{ getResultText(xingcaiDetail.cashang) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.cashang) }}</div>
            </div>
            <div v-show="xingcaiDetail.cashang">
              <el-image v-for="imageUrl in xingcaiDetail.cashang_pics_list" :preview-src-list="xingcaiDetail.cashang_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">模痕：</div>
              <div v-if="xingcaiDetail.mohen" style="color: red">{{ getResultText(xingcaiDetail.mohen) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.mohen) }}</div>
            </div>
            <div v-show="xingcaiDetail.mohen">
              <el-image v-for="imageUrl in xingcaiDetail.mohen_pics_list" :preview-src-list="xingcaiDetail.mohen_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>

            <div class="nowrapDiv">
              <div class="fontBold">角度不良：</div>
              <div v-if="xingcaiDetail.jiaodu" style="color: red">{{ getResultText(xingcaiDetail.jiaodu) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.jiaodu) }}</div>
            </div>
            <div v-show="xingcaiDetail.jiaodu">
              <el-image v-for="imageUrl in xingcaiDetail.jiaodu_pics_list" :preview-src-list="xingcaiDetail.jiaodu_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">撞伤：</div>
              <div v-if="xingcaiDetail.zhuangshang" style="color: red">{{ getResultText(xingcaiDetail.zhuangshang) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.zhuangshang) }}</div>
            </div>
            <div v-show="xingcaiDetail.zhuangshang">
              <el-image v-for="imageUrl in xingcaiDetail.zhuangshang_pics_list" :preview-src-list="xingcaiDetail.zhuangshang_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">暗影：</div>
              <div v-if="xingcaiDetail.anying" style="color: red">{{ getResultText(xingcaiDetail.anying) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.anying) }}</div>
            </div>
            <div v-show="xingcaiDetail.anying">
              <el-image v-for="imageUrl in xingcaiDetail.anying_pics_list" :preview-src-list="xingcaiDetail.anying_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">平面不良：</div>
              <div v-if="xingcaiDetail.pingmian" style="color: red">{{ getResultText(xingcaiDetail.pingmian) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.pingmian) }}</div>
            </div>
            <div v-show="xingcaiDetail.pingmian">
              <el-image v-for="imageUrl in xingcaiDetail.pingmian_pics_list" :preview-src-list="xingcaiDetail.pingmian_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">夹渣：</div>
              <div v-if="xingcaiDetail.jiazha" style="color: red">{{ getResultText(xingcaiDetail.jiazha) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.jiazha) }}</div>
            </div>
            <div v-show="xingcaiDetail.jiazha">
              <el-image v-for="imageUrl in xingcaiDetail.jiazha_pics_list" :preview-src-list="xingcaiDetail.jiazha_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">变形：</div>
              <div v-if="xingcaiDetail.bianxing" style="color: red">{{ getResultText(xingcaiDetail.bianxing) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.bianxing) }}</div>
            </div>
            <div v-show="xingcaiDetail.bianxing">
              <el-image v-for="imageUrl in xingcaiDetail.bianxing_pics_list" :preview-src-list="xingcaiDetail.bianxing_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">气泡：</div>
              <div v-if="xingcaiDetail.qipao" style="color: red">{{ getResultText(xingcaiDetail.qipao) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.qipao) }}</div>
            </div>
            <div v-show="xingcaiDetail.qipao">
              <el-image v-for="imageUrl in xingcaiDetail.qipao_pics_list" :preview-src-list="xingcaiDetail.qipao_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">齿印：</div>
              <div v-if="xingcaiDetail.chiyin" style="color: red">{{ getResultText(xingcaiDetail.chiyin) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.chiyin) }}</div>
            </div>
            <div v-show="xingcaiDetail.chiyin">
              <el-image v-for="imageUrl in xingcaiDetail.chiyin_pics_list" :preview-src-list="xingcaiDetail.chiyin_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">短装：</div>
              <div v-if="xingcaiDetail.duanzhuang" style="color: red">{{ getResultText(xingcaiDetail.duanzhuang) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.duanzhuang) }}</div>
            </div>
            <div v-show="xingcaiDetail.duanzhuang">
              <el-image v-for="imageUrl in xingcaiDetail.duanzhuang_pics_list" :preview-src-list="xingcaiDetail.duanzhuang_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">钉眼：</div>
              <div v-if="xingcaiDetail.dinyan" style="color: red">{{ getResultText(xingcaiDetail.dinyan) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.dinyan) }}</div>
            </div>
            <div v-show="xingcaiDetail.dinyan">
              <el-image v-for="imageUrl in xingcaiDetail.dinyan_pics_list" :preview-src-list="xingcaiDetail.dinyan_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">异物卷入：</div>
              <div v-if="xingcaiDetail.yiwu" style="color: red">{{ getResultText(xingcaiDetail.yiwu) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.yiwu) }}</div>
            </div>
            <div v-show="xingcaiDetail.yiwu">
              <el-image v-for="imageUrl in xingcaiDetail.yiwu_pics_list" :preview-src-list="xingcaiDetail.yiwu_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">颜色错误：</div>
              <div v-if="xingcaiDetail.yanse" style="color: red">{{ getResultText(xingcaiDetail.yanse) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.yanse) }}</div>
            </div>
            <div v-show="xingcaiDetail.yanse">
              <el-image v-for="imageUrl in xingcaiDetail.yanse_pics_list" :preview-src-list="xingcaiDetail.yanse_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">光伤：</div>
              <div v-if="xingcaiDetail.guangshang" style="color: red">{{ getResultText(xingcaiDetail.guangshang) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.guangshang) }}</div>
            </div>
            <div v-show="xingcaiDetail.guangshang">
              <el-image v-for="imageUrl in xingcaiDetail.guangshang_pics_list" :preview-src-list="xingcaiDetail.guangshang_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">标签与实物不符：</div>
              <div v-if="xingcaiDetail.biao_qian" style="color: red">{{ getResultText(xingcaiDetail.biao_qian) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.biao_qian) }}</div>
            </div>
            <div v-show="xingcaiDetail.biao_qian">
              <el-image v-for="imageUrl in xingcaiDetail.biao_qian_pics_list" :preview-src-list="xingcaiDetail.biao_qian_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>

            <div class="nowrapDiv">
              <div class="fontBold">其他：</div>
              <div v-if="xingcaiDetail.qita" style="color: red">{{ getResultText(xingcaiDetail.qita) }}</div>
              <div v-else>{{ getResultText(xingcaiDetail.qita) }}</div>
            </div>
            <div v-show="xingcaiDetail.qita">
              <el-image v-for="imageUrl in xingcaiDetail.qita_pics_list" :preview-src-list="xingcaiDetail.qita_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">弯曲度：</div>
              <div v-if="xingcaiDetail.wanqudu_result">{{ xingcaiDetail.wanqudu }}</div>
              <div v-else style="color: red">{{ xingcaiDetail.wanqudu }}</div>
              <div style="margin-left: 10px">{{"标准值:" +  (Number)(xingcaiDetail.wanQuDuStandard).toFixed(1) }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">扭拧度：</div>
              <div v-if="xingcaiDetail.niuningdu_result">{{ xingcaiDetail.niuningdu }}</div>
              <div v-else style="color: red">{{ xingcaiDetail.niuningdu }}</div>
              <div style="margin-left: 10px">{{"标准值:" +  (Number)(xingcaiDetail.niuNingDuStandard).toFixed(1) }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ xingcaiDetail.remark }}</div>
            </div>
            <el-image v-show="xingcaiDetail.pictures_pics_ids !== ''" v-for="imageUrl in xingcaiDetail.pictures_pics_list" :preview-src-list="xingcaiDetail.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="硬度" :disabled="xingcaiDetail.hardness_status === undefined">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{xingcaiDetail.wujian_id}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{xingcaiDetail.wujian_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">订单号</div>
                <div>{{xingcaiDetail.purchase_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">型材番号</div>
                <div>{{xingcaiDetail.xingcai_no}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">到货数</div>
                <div>{{xingcaiDetail.in_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">入荷日</div>
                <div>{{xingcaiDetail.in_date}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">长度</div>
                <div>{{xingcaiDetail.length}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">幅宽/W</div>
                <div>{{xingcaiDetail.breadth}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查数量</div>
                <div>{{xingcaiDetail.checked_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">判定结果</div>
                <div>{{xingcaiYingduDetail.resultText}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{xingcaiYingduDetail.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{xingcaiYingduDetail.create_time}}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">判断标准类型：</div>
                <div>{{xingcaiYingduDetail.hardness_typeText}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">判断标准：</div>
                <div>硬度{{xingcaiYingduDetail.standard_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">数值一：</div>
                <div>{{xingcaiYingduDetail.hardness_value1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">数值二：</div>
                <div>{{xingcaiYingduDetail.hardness_value2}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">数值三：</div>
                <div>{{xingcaiYingduDetail.hardness_value3}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">数值四：</div>
                <div>{{xingcaiYingduDetail.hardness_value4}}</div>
              </div>
            </div>
            <div v-show="xingcaiYingduDetail.pictures_pics_ids !== ''">
              <el-image v-for="imageUrl in xingcaiYingduDetail.pictures_pics_list" :preview-src-list="xingcaiYingduDetail.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="尺寸" :disabled="xingcaiDetail.chicun_status === undefined">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{xingcaiSizeDetail.wujian_id}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{xingcaiSizeDetail.wujian_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">订单号</div>
                <div>{{xingcaiSizeDetail.purchase_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">型材番号</div>
                <div>{{xingcaiSizeDetail.xingcai_no}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">到货数</div>
                <div>{{xingcaiSizeDetail.in_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查数</div>
                <div>{{xingcaiSizeDetail.checked_count}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">长度</div>
                <div>{{xingcaiSizeDetail.length}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">入库日期</div>
                <div>{{xingcaiSizeDetail.in_date}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查编号</div>
                <div>{{xingcaiSizeDetail.check_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">判定结果</div>
                <div>{{xingcaiSizeDetail.resultText}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{xingcaiSizeDetail.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{xingcaiSizeDetail.create_time}}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div v-show="xingcaiSizeItemList.length !== 0">
              <div style="display: flex;justify-content: center;">
                <el-image class="imageStyle1" :src="xingcaiSizeItemList[0]?.url" :preview-src-list="[xingcaiSizeItemList[0]?.url]" fit="fill"></el-image>
              </div>
              <div class="nowrapDiv" v-for="sizeItem in xingcaiSizeItemList" v-bind:key="sizeItem.id">
                <div class="detailDiv">
                  <div class="fontBold">位置{{sizeItem.point_mark}}实测值：</div>
                  <div v-if="sizeItem.result === 'false'" style="color: red">{{sizeItem.measured_value}}</div>
                  <div v-else>{{sizeItem.measured_value}}</div>
                </div>
                <div class="detailDiv">
                  <div class="fontBold">{{sizeItem.point_mark}}标准值：</div>
                  <div>{{ getStandardValueString(sizeItem) }}</div>
                </div>
              </div>
            </div>
            <div v-show="xingcaiSizeDetail.pictures_pics_ids !== ''">
              <el-image v-for="imageUrl in xingcaiSizeDetail.pictures_pics_list" :preview-src-list="xingcaiSizeDetail.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="膜厚" :disabled="xingcaiDetail.thickness_status === undefined">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{xingcaiDetail.wujian_id}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{xingcaiDetail.wujian_name}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">订单号</div>
                <div>{{xingcaiDetail.purchase_no}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">型材番号</div>
                <div>{{xingcaiDetail.xingcai_no}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">到货数</div>
                <div>{{xingcaiDetail.in_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">入荷日</div>
                <div>{{xingcaiDetail.in_date}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">长度</div>
                <div>{{xingcaiDetail.length}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">幅宽/W</div>
                <div>{{xingcaiDetail.breadth}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查数量</div>
                <div>{{xingcaiDetail.checked_count}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">判定结果</div>
                <div>{{xingcaiThicknessDetail.resultText}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{xingcaiThicknessDetail.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{xingcaiThicknessDetail.create_time}}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">判断标准：</div>
                <div>膜厚{{xingcaiThicknessDetail.standard_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">平均值：</div>
                <div>{{xingcaiThicknessDetail.average_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">数值一：</div>
                <div>{{xingcaiThicknessDetail.value1}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">数值二：</div>
                <div>{{xingcaiThicknessDetail.value2}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">数值三：</div>
                <div>{{xingcaiThicknessDetail.value3}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">数值四：</div>
                <div>{{xingcaiThicknessDetail.value4}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="fontBold">数值五：</div>
                <div>{{xingcaiThicknessDetail.value5}}</div>
              </div>
              <div class="detailDiv">
                <div class="fontBold">数值六：</div>
                <div>{{xingcaiThicknessDetail.value6}}</div>
              </div>
            </div>
            <div v-show="xingcaiThicknessDetail.pictures_pics_ids !== ''">
              <el-image v-for="imageUrl in xingcaiThicknessDetail.pictures_pics_list" :preview-src-list="xingcaiThicknessDetail.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "BusXingcaiCheckInfo",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      xingcaiDetail:{},
      xingcaiYingduDetail:{},
      xingcaiSizeDetail:{},
      xingcaiSizeItemList:[],
      xingcaiThicknessDetail:{}
    }
  },
  methods:{
    getStandardValueString(sizeItem){
      if(sizeItem.type === 'symmetric'){
        return sizeItem.standard_value + '+/-' + sizeItem.error_range;
      }else if(sizeItem.type === 'inSymmetric'){
        return sizeItem.standard_value + '+' + sizeItem.error_rangeplus + '/-' + sizeItem.error_rangereduce;
      }else{
        if((sizeItem.lower_value != null && sizeItem.lower_value !== 0) && (sizeItem.upper_value != null && sizeItem.upper_value !== 0)) {
          if(sizeItem.include_lower && sizeItem.include_upper){
            return '('+sizeItem.lower_value + '~' + sizeItem.upper_value+')';
          }else if(!sizeItem.include_lower && !sizeItem.include_upper){
            return '['+sizeItem.lower_value + '~' + sizeItem.upper_value+']';
          }else if(!sizeItem.include_lower && sizeItem.include_upper){
            return '['+sizeItem.lower_value + '~' + sizeItem.upper_value+')';
          }else{
            return '('+sizeItem.lower_value + '~' + sizeItem.upper_value+']';
          }
        } else if(sizeItem.lower_value != null && sizeItem.lower_value !== 0) {
          return (sizeItem.include_lower ? '>' : '>=') + sizeItem.lower_value;
        } else if(sizeItem.upper_value != null && sizeItem.upper_value !== 0) {
          return (sizeItem.include_upper ? '<' : '<=') + sizeItem.upper_value;
        } else {
          return '标准值设置错误';
        }
      }
    },
    getResultText(result){
      return result ? "有":"无"
    },
    async getXingcaiDetail(){
      let {data: res} = await this.$axios.get('/api/xingcai/waiguan/detailWeb?checkNo=' + this.parentData.check_no);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.xingcaiDetail = res.data
        if (this.xingcaiDetail.hardness_status !== undefined){
          let {data: res} = await this.$axios.get('/api/xingcai/yingdu/detail?waiguanId=' + this.xingcaiDetail.id);
          if (res.message !== "") {
            this.$message.error(res.message);
          } else {
            this.xingcaiYingduDetail = res.data
          }
        }
        if (this.xingcaiDetail.chicun_status !== undefined){
          let {data: res} = await this.$axios.get('/api/xingcai/size/detail1?waiguanId=' + this.xingcaiDetail.id);
          if (res.message !== "") {
            this.$message.error(res.message);
          } else {
            this.xingcaiSizeDetail = res.data
          }
          let {data: res1} = await this.$axios.get('/api/xingcai/size/item/list?checkId=' + this.xingcaiSizeDetail.id);
          if (res1.message !== "") {
            this.$message.error(res1.message);
          } else {
            this.xingcaiSizeItemList = res1.data

          }
        }
        if (this.xingcaiDetail.thickness_status !== undefined){
          let {data: res} = await this.$axios.get('/api/xingcai/thickness/detail?waiguanId=' + this.xingcaiDetail.id);
          if (res.message !== "") {
            this.$message.error(res.message);
          } else {
            this.xingcaiThicknessDetail = res.data
          }
        }
      }
    }
  },
  created() {
    this.getXingcaiDetail()
  }
}
</script>

<style scoped>
.checkInfo{
  background-color: #F4F8FD;
  padding-top: 2px;
}
.detail{
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}
.detailDiv{
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fontBold{
  font-weight: bold;
}
.width1{
  width: 25%;
}
.width2{
  width: 39%;
}
.width3{
  width: 12.5%;
}
.width4{
  width: 30%;
}
.width5{
  width: 50%;
}
.nowrapDiv{
  display: flex;
  flex-wrap: nowrap;
}
.ngdiv{
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}
.ngdiv1{
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}
.imageStyle{
  width: 87px;
  height: 87px;
  margin-right: 5px
}
.imageStyle1{
  width: 500px;
  height: 500px;
  margin-right: 5px
}
>>> .el-tabs--border-card>.el-tabs__content {
  padding: 1px !important;
}
</style>
